export const roleFr = {
  "Role": "Role",
  "Nom du role": "Nom du role",
  "Enregistrer": "Enregistrer",

  // Server Side

  "Le nom existe deja": "Le nom existe deja",
  "Le nom du role est obligatoire": "Le nom du role est obligatoire",
  "Le nom du role doit etre superieur a 3 caracteres": "Le nom du role doit etre superieur a 3 caracteres",
  

}